"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinWidth = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const throttle_debounce_1 = require("throttle-debounce");
exports.MinWidth = ({ width, style, children, ...props }) => {
    const ref = react_1.useRef(null);
    const [show, setShow] = react_1.useState(false);
    react_1.useEffect(() => {
        const updateSize = throttle_debounce_1.throttle(250, () => {
            setShow(ref.current !== null && ref.current.clientWidth > width);
        });
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => {
            window.removeEventListener("resize", updateSize);
        };
    }, [width]);
    return (react_1.default.createElement("div", Object.assign({ ref: ref, style: { visibility: show ? "visible" : "hidden", ...style } }, props), children));
};
exports.MinWidth.propTypes = {
    width: prop_types_1.default.number.isRequired,
    style: prop_types_1.default.any,
    children: prop_types_1.default.node.isRequired,
};
//# sourceMappingURL=MinWidth.js.map